import React from 'react';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { useIsAdmin, useIsManager, useIsUser, useStore } from 'hooks';
import { Button, ButtonAdd, ButtonClose } from 'components/ui/form';
import { ApplicationWagonService } from 'services';
import styles from './menu.module.scss';

const Menu = ({
  onAdd,
  titleAdd = 'Добавить',
  textAdd = 'Добавить',
  history,
  match: {
    params: { userId },
  },
  rightFilter,
}) => {
  const { setUser } = useStore();
  const isUser = useIsUser();
  const isAdmin = useIsAdmin();
  const isManager = useIsManager();
  const isAdminOrManager = isAdmin || isManager;
  const isProfile = isAdminOrManager && Number(userId) >= 0;

  const checkFile = async (type = 0) => {
    const res = await new ApplicationWagonService({ setUser }).getConsolidationFiles({ type });
    if (res) {
      window.open(`${process.env.API_URL}/user/application-wagon/consolidate?type=${type}`);
    }
  };

  return (
    <div className={styles.menu}>
      <div className={styles.links}>
        <div className={styles.topRow}>
          <ul>
          {isProfile ? (
            <>
              <li>
                <NavLink exact activeClassName={styles.active} to={`/profile/${userId}`}>Профиль</NavLink>
              </li>
              <li>
                <NavLink activeClassName={styles.active} to={`/profile/${userId}/applications`}>Заявки</NavLink>
              </li>
              <li>
                <NavLink exact activeClassName={styles.active} to={`/profile/${userId}/consignees`}>Грузополучатели</NavLink>
              </li>
              <li>
                <NavLink exact activeClassName={styles.active} to={`/profile/${userId}/contacts`}>Контакты</NavLink>
              </li>
              <li>
                <NavLink exact activeClassName={styles.active} to={`/profile/${userId}/contracts`}>Контракты</NavLink>
              </li>
            </>
          ) : (
            <>
              {isUser ? (
                <>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/profile">Профиль</NavLink>
                  </li>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/profile/consignees">Грузополучатели</NavLink>
                  </li>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/consignees/catalog">Грузополучатели (Справочник)</NavLink>
                  </li>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/profile/contacts">Контакты</NavLink>
                  </li>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/profile/contracts">Контракты</NavLink>
                  </li>
                </>
              ) : null}
              {isAdminOrManager ? (
                <>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/profile">Профиль</NavLink>
                  </li>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/users">Пользователи</NavLink>
                  </li>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/notifications">Центр рассылки уведомлений</NavLink>
                  </li>
                  <li>
                    <NavLink exact activeClassName={styles.active} to="/export-settings">Внутренние направления и экспорт</NavLink>
                  </li>
                  {isAdmin && (
                    <>
                      <li>
                        <NavLink exact activeClassName={styles.active} to="/products">Продукция</NavLink>
                      </li>
                      <li>
                        <NavLink exact activeClassName={styles.active} to="/stations">Станции</NavLink>
                      </li>
                      <li>
                        <NavLink exact activeClassName={styles.active} to="/directions">Направления</NavLink>
                      </li>
                      <li>
                        <NavLink exact activeClassName={styles.active} to="/consignees/catalog">Грузополучатели</NavLink>
                      </li>
                      <li>
                        <NavLink exact activeClassName={styles.active} to="/production-capacities">Производственные мощности</NavLink>
                      </li>
                      <li>
                        <NavLink exact activeClassName={styles.active} to="/archive-execution">Выполнить архивацию</NavLink>
                      </li>
                      <li>
                        <NavLink exact activeClassName={styles.active} to="/logs-list">История действий</NavLink>
                      </li>
                    </>
                  )}
                </>
              ) : null}
            </>
          )}
          </ul>
          <div className={styles.actions}>
            {isProfile && (
              <ButtonClose
                title="Закрыть профиль"
                onClick={() => history.push('/users')}
              >
                Закрыть
              </ButtonClose>
            )}
            {onAdd && (
              <ButtonAdd title={titleAdd} onClick={onAdd}>{textAdd}</ButtonAdd>
            )}
          </div>
        </div>
        {isAdminOrManager && !isProfile && (
          <div className={rightFilter ? `${styles.download} ${styles.downloadWithFilter}` : styles.download}>
            <div className={styles.downloadButtons}>
              <Button className={styles.downloadBtn} onClick={() => { checkFile(); }}>
                Сформировать ГУ
              </Button>
              <Button className={styles.downloadBtn} onClick={() => { checkFile(1); }}>
                Сформировать ДГУ
              </Button>
            </div>
            {rightFilter}
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(Menu);
